import { render, staticRenderFns } from "./TasksLunchHeader.vue?vue&type=template&id=63c85873&"
import script from "./TasksLunchHeader.vue?vue&type=script&lang=js&"
export * from "./TasksLunchHeader.vue?vue&type=script&lang=js&"
import style0 from "./TasksLunchHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports